import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

type IMarginable = {
  margin?: number | string;
};

export const MobileOnlyContent = styled.div`
  display: block;
  width: 100%;
  ${Styles.desktop`
    display: none;
  `}
  // it wouldn't display on Pixel phones when it was switched to Landscape mode
  // this ensures we still get the mobile content on pixel devices in Landscape mode
  @media only screen and (min-width: 820px) and (max-width: 828px) and (min-height: 400px) and (max-height: 415px) {
    display: block;
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  ${Styles.mobile`
    margin-bottom: calc(env(safe-area-inset-bottom) + 100px);
  `}
`;

export const ContentBlock = styled.div<IMarginable>`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: ${props => (props.margin ? props.margin : '1.5rem 0')};
  width: 100%;
`;

export const BarcodeContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 2rem 0;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const Heading = styled.h3`
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 1.375rem;
  color: ${primitive.th.$coffeeBrown};
  margin: 0;
  text-align: center;
`;

export const SubHeading = styled.h5`
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.normal};
  color: ${primitive.th.$coffeeBrown};
  margin: 0;
  text-align: center;
`;

export const Separator = styled.div<IMarginable>`
  border-top: solid 1px #000;
  height: 1px;
  opacity: 0.2;
  margin: ${props => (props.margin ? props.margin : '0.5rem 0')};
  width: 100%;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
`;

export const TextButtonsWrapper = styled.div`
  width: fill-available;
  height: 100%;
  margin: 0 -${primitive.$spacing5};
`;

export const FullLineSeparator = styled(Separator)`
  width: fill-available;
`;
